import { AbstractCounter } from './AbstractCounter';
import { CurrencyName } from '../../../core/managers/Inventory';

export class CoinsCounter extends AbstractCounter {
  constructor(parent?: PIXI.Container) {
    super(parent);
  }

  protected initParams(): void {
    this.iconName = 'coin_icon@2x';
    this.resourceName = CurrencyName.Coins;
  }
}